import React from 'react';

type SkeletonAnimation = 'pulse' | 'wave' | 'none';

interface SkeletonBlockProps {
  width?: string | number; // Defaults to 100% of parent container
  height?: string | number; // Defaults to 100% of parent container
  minHeight?: string | number; // Minimum height to prevent collapsing
  borderRadius?: string | number;
  animation?: SkeletonAnimation;
}

/**
 * A generic skeleton placeholder block that automatically fills the
 * width/height of its parent container, unless explicit width/height
 * are provided. Useful for modal bodies or any container-agnostic
 * loading placeholder.
 */
export const SkeletonBlock: React.FC<SkeletonBlockProps> = ({
  width = '100%',
  height = '100%',
  borderRadius = 6,
  animation = 'wave',
  minHeight = 120, // Set a minimum height to avoid collapsing
}) => {
  return (
    <div
      className="skeleton skeleton-block"
      style={{ width, height, borderRadius, minHeight }}
    />
  );
};

export default SkeletonBlock;
